import { useMemo, useRef } from 'react';
import cm from 'classnames';
import { useResizeObserver } from 'hooks/use-resize-observer';
import styles from './_time-label.module.scss';

const LABEL_WIDTH = +styles.timeLabelWidth.match(/\d+/)![0];
const VAR__POSITION = '--position';

export type TimeLabelPayload = {
  cssPosition: string;
  time: Seconds;
};

interface Props {
  className?: string;
  payload: TimeLabelPayload;
  enable: boolean;
  invert: boolean;
}

export const TimeLabel = ({ payload, enable, invert, className }: Props) => {
  const root = useRef<HTMLDivElement>(null);
  const posEl = useRef<HTMLDivElement>(null);
  const rootWidth = useRef(0);

  const reflect = useMemo(() => {
    if (!enable) return;
    if (!posEl.current) return;
    root.current?.style.setProperty(VAR__POSITION, payload.cssPosition);
    return rootWidth.current - posEl.current!.offsetLeft <= LABEL_WIDTH;
  }, [payload]);

  useResizeObserver(root.current, () => (rootWidth.current = root.current!.offsetWidth));

  return (
    <div
      ref={root}
      className={cm(styles.TimeLabel, className, {
        [styles['TimeLabel--enable']]: enable,
        [styles['TimeLabel--invert']]: invert,
        [styles['TimeLabel--reflect']]: reflect,
      })}
    >
      <div ref={posEl} className={styles.TimeLabel__position} />
      <div className={styles.TimeLabel__element}>{formatTime(payload.time)}</div>
    </div>
  );
};

/* H E L P E R */

const formatTime = (value: Seconds): string => {
  const totalSeconds = Math.floor(value);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const milliseconds = Math.floor((value - totalSeconds) * 1000);
  const formatDecimal = (val: number) => (val > 9 ? val : '0' + val);
  const formatHundredths = (val: number) => (val > 99 ? val : val > 9 ? '0' + val : '00' + val);
  return formatDecimal(minutes) + ':' + formatDecimal(seconds) + '.' + formatHundredths(milliseconds);
};
